import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addCity, deleteCity, fetchCityList, updateCity } from "./CityListAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCityListAsync = createAsyncThunk(
  "CityList/fetch",
  async (page, { rejectWithValue }) => {
    try {
      const data = await fetchCityList(page);

      const resp = data.response;
      // console.log("data's response", data.response)

      return {
        cities: resp.data,  // The array of job data
        totalCities: resp.total,  
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteCityListAsync = createAsyncThunk(
  'CityList/delete',
  async (uuuuid, { rejectWithValue }) => {
    try {
      await deleteCity(uuuuid);
      return uuuuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCityListAsync = createAsyncThunk(
  'CityList/update',
  async ({ uuid, cityData }, { rejectWithValue }) => {
    try {
      const response = await updateCity(uuid, cityData);
      console.log("Response Slice", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addCityListAsync = createAsyncThunk(
  "CityList/add",
  async (newCity) => {
    try {
      const data = await addCity(newCity);
      console.log("data in slice", data)
      return data;
    } catch (error) {
      console.log("errorL :" , error)
      // return rejectWithValue(error.message);
    }
  }
);

const CitySlice = createSlice({
  name: "City",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCityListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCityListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchCityListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(addCityListAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addCityListAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateCityListAsync.pending, (state) => {
        state.loading = true;
        // console.log("Loading")
        state.error = null;
      })
      .addCase(updateCityListAsync.fulfilled, (state, action) => {
        state.loading = false;
        // console.log("data", state.data)
        state.data = state.data.map((cityData) =>
            cityData.uuid === action.payload.uuid ? action.payload : cityData
        );
      })
      .addCase(updateCityListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteCityListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCityListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (cityData) => cityData.uuid !== action.payload
        );
      })
      .addCase(deleteCityListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});
export const selectCity = (state) => state.city.data.cities;
export const selectCityTotal = (state) => state.city.data.totalCities;

export default CitySlice.reducer;
